import { useEffect, useState } from "react";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import GeneralTable from "../Tabellen/GeneralTable";
import { hiddenColumns, notizenHeader } from "../Tabellen/ConstTabKopf/NotizenHeader";

export default function NotizenLaden({ noteInstance }) {

    const [allNotes, setAllNotes] = useState([]);
    const [noData, setNoData] = useState();

    useEffect(() => {
        noteInstance.getNotizen((error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setAllNotes(data);
                setNoData(data.length === 0);
            }
        });
    }, [noteInstance])

    return (
        <div>
            <p>
                Hier sind alle Prozesse aufgelistet, die automatisch statt gefunden haben, um die Datenkonsistenz zu erhalten.
            </p>
            {allNotes && <div>
                <GeneralTable data={allNotes} columns={notizenHeader} hiddenColumns={hiddenColumns} additionalColumns={[]} />
            </div>}
            {noData && <p>Keine Notizen vorhanden.</p>}
        </div>
    )
}